<form [formGroup]="settingForm" class="example-form settings-form my-3">
    <mat-form-field>
        <mat-label>{{'FORM.settingForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
    </mat-form-field>
    
    <mat-form-field [hidden]="hideCommentField">
        <mat-label>{{'FORM.settingForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput></textarea>
    </mat-form-field>

    <mat-form-field [hidden]="hideColorPicker">
        <mat-label>Color</mat-label>
        <input formControlName="color" matInput type="color">
    </mat-form-field>

    <mat-form-field [hidden]="hideColorPicker">
        <mat-label>{{'FORM.gOLineTypesForm.lineColorNameOpacity' | translate}}</mat-label>
        <input formControlName="colorOpacity" id="opacityNumber" style="width:100%;" type="range" name="opacity" min="0" max="100" step="1" [value]="settingForm.value.colorOpacity" oninput="amount.value = opacityNumber.value" >
        <input formControlName="colorOpacity" matInput id="amount" type="number" [value]="settingForm.value.colorOpacity" min="0" max="100" step="1" oninput="opacityNumber.value=amount.value" />
        <p style="display:none;">{{settingForm.value.colorOpacity}}</p>
    </mat-form-field>

    <div>
        <button [disabled]="settingForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button type="submit" (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>
</form>
